import {
  SET_USER,
} from 'common/actions/user';

export default function routes(state = {
  isFetching: false,
  user: null,
}, action) {
  switch (action.type) {
    case SET_USER:
      return Object.assign({}, state, {
        user: action.user,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/user.js